import React, { useEffect } from 'react';
import { exportToExcel } from 'src/utils/Common';
import { BottomNavigationAction, Button } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useTranslation } from 'react-i18next';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';

function ExcelExport({ JsonData, ButtonType, DirectDownload = false, filename = 'Download' }) {
  const { t } = useTranslation('overview');
  filename = filename + ' - ' + new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).replaceAll(':', '.');
  if (JsonData.length === 0) {
    return (
      <>
        {
          ButtonType === 1 ?
            <BottomNavigationAction
              disabled={true}
              showLabel label={t('lblExport')} icon={<CloudDownloadIcon />} />
            : ButtonType === 2 ?
              <Button
                variant="contained"
                color="primary"
                fullWidth
                size="small"
                disabled={true}
                startIcon={<CloudDownloadOutlinedIcon />}
              >
                {t('lblExport')}
              </Button>

              : ButtonType === 3 ?
                <Button
                  variant="contained"
                  color="primary"
                  disabled={true}
                  startIcon={<CloudDownloadOutlinedIcon />}
                >
                  {t('lblExport')}
                </Button>
                :
                ButtonType === 5 ? //ERP Detail 
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="small"
                    // disabled={true}
                    startIcon={<CloudDownloadOutlinedIcon />}
                  >
                    {'ERP' + t('lblExport')}
                  </Button>
                  :
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    fullWidth
                    disabled={true}
                    startIcon={<CloudDownloadOutlinedIcon />}
                  >
                    {t('lblExport')}
                  </Button>
        }
      </>
    )
  }

  return (
    // <ExcelFile
    //   hideElement={DirectDownload}
    //   filename={filename}
    //   element={ButtonType === 1 ? <BottomNavigationAction showLabel label={t('lblExport')} icon={<CloudDownloadIcon />} />
    //     : ButtonType === 2 ?
    //       <Button
    //         variant="contained"
    //         color="primary"
    //         fullWidth
    //         size="small"
    //         startIcon={<CloudDownloadOutlinedIcon />}
    //       >
    //         {t('lblExport')}
    //       </Button>
    //       :
    //       ButtonType === 3 ?
    //         <Button
    //           variant="contained"
    //           color="primary"
    //           startIcon={<CloudDownloadOutlinedIcon />}
    //         >
    //           {t('lblExport')}
    //         </Button>
    //         :
    //         ButtonType === 5 ? //Erp Detail export 
    //           <Button
    //             variant="contained"
    //             color="primary"
    //             fullWidth
    //             size="small"
    //             startIcon={<CloudDownloadOutlinedIcon />}
    //           >
    //             {'ERP' + t('lblExport')}
    //           </Button>
    //           :
    //           <Button
    //             variant="contained"
    //             color="primary"
    //             size="small"
    //             fullWidth
    //             startIcon={<CloudDownloadOutlinedIcon />}
    //           >
    //             {t('lblExport')}
    //           </Button>

    //   }>

    //   <ExcelSheet data={JsonData} name="Report">
    //     {
    //       JsonData[0] && Object.keys(JsonData[0]).map((value, index) => (
    //         <ExcelColumn label={t(value) !== value ? t(value) : t('lbl' + value)} value={value} />
    //       ))
    //     }
    //   </ExcelSheet>

    // </ExcelFile>
    <>
      {
        ButtonType === 1 ?
          <BottomNavigationAction
            showLabel label={t('lblExport')}
            icon={<CloudDownloadIcon
              style={{ color: '#1E5128' }}
              fontSize="large" />}

            onClick={() => exportToExcel(JsonData, 'ExportedData')}
          />
          : ButtonType === 2 ?
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<CloudDownloadOutlinedIcon />}
              onClick={() => exportToExcel(JsonData, 'ExportedData')}
            >
              {t('lblExport')}
            </Button>
            : ButtonType === 3 ?
              <Button
                size="small"
                variant="contained"
                color="primary"
                fullWidth
                endIcon={<CloudDownloadIcon />}
                onClick={() => exportToExcel(JsonData, 'ExportedData')}
              >
                {t('lblDetailedExport')}
              </Button> :
              ButtonType === 5 ?
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  fullWidth
                  endIcon={<CloudDownloadIcon />}
                  onClick={() => exportToExcel(JsonData, 'ExportedData')}
                >
                   {'ERP' + t('lblExport')}
                </Button> :
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<CloudDownloadOutlinedIcon />}
                  onClick={() => exportToExcel(JsonData, 'ExportedData')}
                >
                  {t('lblExport')}
                </Button>

      }
    </>
  );
}

ExcelExport.propTypes = {

};

export default ExcelExport;
